import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import {
  ManageRkaasLayout,
  CsplTable as Table,
  LoaderWrapper,
  AddToolTip,
} from "../../../../components";
import {
  MANAGE_RKAAS_ROUTES,
  manageRkaasFormNames,
  formFields,
  FLOW_TYPES,
  getAdvancedPathWithParam,
  OPTIONS_DATA_MAPPER,
  INVESTMENT_RECORDS_TO_FETCH,
} from "../../../../utils";
import { getMasterInvestmentBySearchCriteria } from "../../../../services";
import { useDeepEffect } from "../../../../abstracts";
import InfiniteScroll from "react-infinite-scroller";
import MasterInvestmentFilter from "./MasterInvestmentFilter";

const columns = [
  {
    label: "Investment Name",
    className: "column-investment-name",
    columnName: "name",
    isSortable: true,
    orderBy: "",
    link: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
  },
  {
    label: "Investment Type",
    className: "column-investment-type",
    columnName: "investmentTypeName",
  },
  {
    label: "Ticker",
    className: "column-investment-ticker",
    columnName: "ticker",
  },
  {
    label: "CUSIP",
    className: "column-investment-cusip",
    columnName: "cusip",
  },
  {
    label: "Investment Status",
    className: "column-investment-status",
    columnName: "status",
    dataMapper: OPTIONS_DATA_MAPPER.INVESTMENT_STATUS_MASTER,
  },
];

const ManageInvestment = (props) => {
  const [filteredValues, setFilteredValues] = useState([]);
  const formName = manageRkaasFormNames.INVESTMENT_FILTER;
  const fields = formFields[formName];
  const [isLoading, setIsLoading] = useState(false);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [request, setRequest] = useState({
    search: "",
    from: 0,
    to: INVESTMENT_RECORDS_TO_FETCH,
  });
  useDeepEffect(() => {
    setIsLoading(true);
    getMasterInvestmentBySearchCriteria(request)
      .then((response) => {
        if (response.length < INVESTMENT_RECORDS_TO_FETCH)
          setStopInfiniteScroll(true);
        if (append) {
          setFilteredValues((filteredValues) => {
            return [...filteredValues, ...response];
          });
        } else setFilteredValues(response);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [request]);

  const onFormSubmit = (values) => {
    setAppend(false);
    setStopInfiniteScroll(false);
    setRequest({
      search: values.search,
      investmentType: values.investmentType,
      investmentStatus: values.investmentStatus,
      from: 0,
      to: INVESTMENT_RECORDS_TO_FETCH,
    });
  };

  const onAddClick = () => {
    const { history } = props;
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_RKAAS_ROUTES.ADD_INVESTMENT,
        pathParam: [FLOW_TYPES.ADD],
      })
    );
  };

  const buttons = [
    {
      label: "New Investment",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onAddClick,
    },
  ];

  return (
    <ManageRkaasLayout
      layoutHeader="Manage Master Investments"
      buttons={buttons}
      pageFlow={FLOW_TYPES.ADD}
    >
      <div className="height-90">
        <LoaderWrapper isLoading={isLoading}>
          {/* {isEmpty(filteredValues) && (
          <AddPlans
            menu="plan"
            subMenu="manageInvestmentsPlan"
            content="No Investments"
            buttonLabel="New Investment"
            onPrimaryClick={onAddClick}
          />
        )} */}

          <div className="trade-container">
            <MasterInvestmentFilter
              fields={fields}
              filteredValues={filteredValues}
              onFormSubmit={onFormSubmit}
            />
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {columns.map((item, index) => {
                    return (
                      <Table.Th key={index} className={item.className}>
                        {item.label}
                      </Table.Th>
                    );
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                <div style={{ overflowY: "scroll", maxHeight: "60vh" }}>
                  <InfiniteScroll
                    pageStart={0}
                    loadMore={() => {
                      setAppend(true);
                      setRequest((request) => {
                        return {
                          ...request,
                          from: filteredValues?.length,
                          to:
                            filteredValues?.length +
                            INVESTMENT_RECORDS_TO_FETCH,
                        };
                      });
                    }}
                    hasMore={!stopInfiniteScroll}
                    initialLoad={false}
                    threshold={100}
                    useWindow={false}
                    loader={
                      !isEmpty(filteredValues) && (
                        <div className="loader" key={0}>
                          Loading ...
                        </div>
                      )
                    }
                  >
                    {!isEmpty(filteredValues) ? (
                      filteredValues.map((investment, index) => {
                        return (
                          <Table.Tr key={index}>
                            {columns.map((item, cellIndex) => {
                              const getContent = () => {
                                if (item.link) {
                                  return investment[item.columnName]?.length >=
                                    15 ? (
                                    <OverlayTrigger
                                      overlay={
                                        <Tooltip>
                                          {investment[item.columnName]}
                                        </Tooltip>
                                      }
                                    >
                                      <Link
                                        to={getAdvancedPathWithParam({
                                          path: item.link,
                                          pathParam: [
                                            FLOW_TYPES.EDIT,
                                            investment.id,
                                          ],
                                        })}
                                      >
                                        {investment[item.columnName].slice(
                                          0,
                                          15
                                        ) + "..."}
                                      </Link>
                                    </OverlayTrigger>
                                  ) : (
                                    <Link
                                      to={getAdvancedPathWithParam({
                                        path: item.link,
                                        pathParam: [
                                          FLOW_TYPES.EDIT,
                                          investment.id,
                                        ],
                                      })}
                                    >
                                      <AddToolTip
                                        name={investment[item.columnName]}
                                      />
                                    </Link>
                                  );
                                }
                                if (item.dataMapper) {
                                  return (
                                    <AddToolTip
                                      name={
                                        item.dataMapper[
                                          investment[item.columnName]
                                        ]
                                      }
                                    />
                                  );
                                }
                                if (
                                  item.columnName === "cusip" ||
                                  item.columnName === "ticker"
                                ) {
                                  if (investment.type === 1) {
                                    return <AddToolTip name={"Multiple"} />;
                                  }
                                  return "-";
                                }
                                return (
                                  <AddToolTip
                                    name={investment[item.columnName]}
                                  />
                                );
                              };

                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  {getContent()}
                                </Table.Td>
                              );
                            })}
                          </Table.Tr>
                        );
                      })
                    ) : (
                      <div class="d-flex align-items-center justify-content-center">
                        No Records Found
                      </div>
                    )}
                  </InfiniteScroll>
                </div>
              </Table.Tbody>
            </Table>
          </div>
        </LoaderWrapper>
      </div>
    </ManageRkaasLayout>
  );
};

export default ManageInvestment;
